import { AspectRatio, Box, Flex } from "@chakra-ui/react";
import PampaImage from "@raiden/library/components/PampaImage";
import useTranslate from "@raiden/library/hooks/useTranslate";
import generateFrontPath from "@raiden/library/libraries/utils/generateFrontPath";
import { useIntl } from "react-intl";
import { CenteredContent } from "../../components/CenteredContent";
import { ContactBand } from "../../components/ContactBand";
import { DataHandler } from "../../components/DataHandler";
import { InterventionAreas } from "../../components/InterventionAreas";
import { PageLayout } from "../../components/PageLayout";
import { Splash } from "../../components/Splash";
import { PostsContentView } from "../Posts/Common/ContentView";

/**
 * @typedef {Object} Props
 * @property {import("swr").SWRResponse<import("@raiden/library/types/Api/ApiResponse").ApiResponse<import("@raiden/library/types/Post").Post>>} swrResponsePost
 */

/**
 * @param {Props} props
 */
export function TheOffice({ swrResponsePost }) {
  const intl = useIntl();

  const translate = useTranslate();

  const postData = swrResponsePost.data?.data;
  const cover = postData?.current_revision?.cover;
  const caption = cover?.caption ? translate(cover.caption) ?? "" : "";

  return (
    <PageLayout
      title={
        translate(postData?.current_revision?.title) ??
        intl.formatMessage({ defaultMessage: "Le cabinet" })
      }
      subtitle={
        translate(postData?.current_revision?.subtitle) ??
        intl.formatMessage({
          defaultMessage: "Notre équipe dédiée à la qualité et à l'efficacité",
        })
      }
      bottomAddon={
        <>
          <InterventionAreas />

          <ContactBand />
        </>
      }>
      <Box>
        <CenteredContent>
          <DataHandler
            swrResponse={swrResponsePost}
            keepDataOnRevalidation={true}
            noResult={
              <Flex alignItems="center" flexDir="column" gap="1rem" mx="auto">
                <Box width={{ base: "200px", lg: "700px" }}>
                  <Splash
                    src={generateFrontPath({
                      id: "@front.internal-assets",
                      parameters: { filePath: "illustrations/error.svg" },
                      includeBasePath: true,
                    })}
                    title={intl.formatMessage({
                      defaultMessage: "Erreur lors du chargement de la page",
                    })}
                  />
                </Box>
              </Flex>
            }>
            {({ data: post }) => (
              <Box>
                {cover && (
                  <AspectRatio ratio={1360 / 570}>
                    <PampaImage
                      image={post.current_revision?.cover}
                      format="default"
                      mode="crop"
                      placeholderSrc={generateFrontPath({
                        id: "@front.internal-assets",
                        parameters: { filePath: "placeholder.png" },
                        includeBasePath: true,
                      })}
                      alt={caption}
                    />
                  </AspectRatio>
                )}

                <PostsContentView post={post ?? undefined} />
              </Box>
            )}
          </DataHandler>
        </CenteredContent>
      </Box>
    </PageLayout>
  );
}
